/*
 * This file includes helper functions that manage
 * the UI configuration of the query form. It helps determine
 * which operators or form components can be shown.
 */

import { QueryRuleFormKeyConfig, QueryRuleFormType } from './query-rule-configs/types';
import { getOperatorsByType, QueryRuleArrayNameType } from '../../queryRulesFormEnums';
import { DateForm } from '../date-form/DateForm';
import { SelectForm } from '../select-form/SelectForm';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { TextForm } from '../text-form/TextForm';

export { getOperatorsByType };

// returns the array of query rule keys that are allowed to be shown as options
// for a specific QueryRuleArrayNameType (one of the boxed sections in the query builder)
export const getKeysByQueryRuleArrayNameType = (
  queryRuleArrayNameType: QueryRuleArrayNameType,
  config: Record<string, QueryRuleFormKeyConfig>
) => {
  if (queryRuleArrayNameType === QueryRuleArrayNameType.NOT) {
    return Object.keys(config)
      .filter((k) => config[k].queryRuleFormType !== QueryRuleFormType.DATE)
      .sort();
  }
  return Object.keys(config).sort();
};

// returns the form component that should be shown
// for a specific QueryRuleFormType (based on the form key being used)
export const getFormComponentByQueryRuleFormType = (queryRuleFormType: QueryRuleFormType | undefined) => {
  switch (queryRuleFormType) {
    case undefined:
      return null;
    case QueryRuleFormType.DATE:
      return DateForm;
    case QueryRuleFormType.SELECT:
      return SelectForm;
    case QueryRuleFormType.TEXT:
    default:
      return TextForm;
  }
};
